import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import DisplayAnalyticsController from './DisplayAnalyticsContorller';
import moment from 'moment';
import OverlaySpinner from '../../../../platform/shared/OverlaySpinner';
import CAMPAIGN_ORDERS_AGGREGATE_BYDATE from '../../../GraphQl/Queries/CAMPAIGN_ORDERS_AGGREGATE_BYDATE';
import LIST_ORGS_ADVERTISERS from '../../../GraphQl/Queries/LIST_ORGS_ADVERTISERS';

const DisplayAnalyticsLoader = ({ children, ...props }) => {
  const loggedInRole = props.currentUser.role;
  const orgId = loggedInRole.org.id;

  const searchParams = new URLSearchParams(props.location.search);
  const advertiserParams = searchParams.get('advertiserId');

  const startDate = searchParams.get('startDate')
    ? searchParams.get('startDate')
    : moment().subtract(6, 'months').seconds(0).milliseconds(0).toISOString();
  const endDate = searchParams.get('endDate')
    ? searchParams.get('endDate')
    : moment().add(1, 'days').seconds(0).milliseconds(0).toISOString();

  const [advertiserIds, setAdvertiserIds] = useState([orgId]);

  useEffect(() => {
    if (!advertiserParams) {
      return setAdvertiserIds([orgId]);
    }
    const advertisers = advertiserParams.split('+');
    setAdvertiserIds(advertisers);
  }, [advertiserParams, orgId]);

  const statusNotIn = ['DRAFT', 'PENDING', 'ARCHIVED'];
  let where = {
    AND: [],
  };

  where['AND'].push({
    type_not: 'CPC',
    status_not: 'ARCHIVED',
  });

  if (startDate && endDate) {
    let paramStartDate = moment(startDate, 'YYYY/MM/DD');
    let paramEndDate = moment(endDate, 'YYYY/MM/DD');

    where['AND'].push({
      OR: [
        {
          startDate_gte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          startDate_lte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
        {
          endDate_gte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          endDate_lte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
        {
          startDate_lte: paramStartDate.seconds(0).milliseconds(0).toISOString(),
          endDate_gte: paramEndDate.seconds(0).milliseconds(0).toISOString(),
        },
      ],
    });
  }

  if (!(advertiserIds.length === 1 && advertiserIds[0] === orgId)) {
    where['AND'].push({
      status_not_in: statusNotIn,
      orgs_some: {
        OR: [
          { id_in: advertiserIds },
          {
            parentOrg_some: {
              id_in: advertiserIds,
            },
          },
        ],
      },
    });
  } else if (orgId) {
    where['AND'].push({
      status_not_in: statusNotIn,
      orgs_some: {
        OR: [
          {
            id: orgId,
          },
          {
            parentOrg_some: {
              id: orgId,
            },
          },
        ],
      },
    });
  }

  const [fetchCampaignOrders, { loading, data, called }] = useLazyQuery(
    CAMPAIGN_ORDERS_AGGREGATE_BYDATE,
    {
      fetchPolicy: 'network-only'
    }
  );

  const [fetchOrgs, { loading: loadingOrgsAdmin, data: orgsData, called: orgsCalled }] = useLazyQuery(
    LIST_ORGS_ADVERTISERS,
    {
      fetchPolicy: 'network-only'
    }
  );

  const whereString = JSON.stringify(where);
  const advertiserIdsString = JSON.stringify(advertiserIds);

  useEffect(() => {
    fetchCampaignOrders({ variables: { where } });
    fetchOrgs({ variables: { orgIds: advertiserIds, first: 1000 } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whereString, advertiserIdsString]);

  if (!called || !orgsCalled || loading || loadingOrgsAdmin) return <OverlaySpinner />;

  return (
    <DisplayAnalyticsController
      {...props}
      children={children}
      data={data}
      startDate={startDate}
      endDate={endDate}
      orgs={orgsData?.orgs || []}
    />
  );
};

export default DisplayAnalyticsLoader;
